<template>
    <div v-loading="loading">
        <h3 style="text-align:center;">{{ $t('reports.feeTypesSalesTitle') }}</h3>
        <div id="chartByFeeType" style="height:400px;width:400px;margin:auto;">
        </div>
        <el-table v-if="showTable"
            :data="summarizedData"
            stripe
            height="400"
            sum-text="Total"
            class="card-shadow--small"
            v-show="summarizedData &&  summarizedData.length || loading === false"
            :default-sort = "{prop: 'value', order: 'descending'}"
            show-summary
            style="width: 100%">
            <el-table-column
            prop="name"
            :label="$t('reports.feeTypeLabel')"
            sortable
            width="180">
            </el-table-column>
            <el-table-column
                prop="value"
                sortable
                :label="$t('common.QtyBt')">
                <template slot-scope="scope">
                    <span>{{ formatNumber(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="value9L"
                sortable
                :label="$t('common.Qty9L')">
                <template slot-scope="scope">
                    <span>{{ formatNumber(scope.row.value9L) }}</span>
                </template>
            </el-table-column>
        </el-table>
</div>
</template>
<script>

import * as echarts from 'echarts';
import salesAPI from '@/services/API/sales'
import portausUtils from '@/utils/portaus-utils';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'SalesByTerritory',
    props: {
        showTable: {
        type: Boolean,
        default: false
        },
        filters: Object,
        type: {
            type: String,
            default: 'VALUE'
        },
        max: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            loading: true,
            data: [],
        }
    },
    components: {
    },
    watch: {
        type: function (val) {
            this.initChart();
        },
        filters: function (val) {
           this.init();
        }
    },
    methods: {
        formatAmount(amount) {
            return portausUtils.formatAmount(amount, this.$i18n.locale);
        },
        formatNumber(amount) {
            return portausUtils.formatNumber(amount, this.$i18n.locale);
        },
        init() {
            this.loading = true;
            if (this.filters.inventoryId == null) return null;
            this.getSalesByFeeTypes(this.filters)
                .then((data) => {
                   
                    this.data = data;
                    
                    this.initChart();
                    this.loading = false;
                }).catch((err) => {
                    this.loading = false;
                })
        },
        getSalesByFeeTypes (filters) {
            return salesAPI.getSalesByFeeTypes(filters);
        },
        initChart () {
            this.chart = echarts.init(document.getElementById('chartByFeeType'));
            this.chart.setOption({
                title: {
                    show:false,
                    text: "Proportion de sans frais",
                    padding:0,
                    left:'center',
                    textAlign:'center'
                },
                tooltip: {
                    show:true,
                    trigger: 'item',
                    appendToBody: true,
                },
                legend: {
                    show:false,
                    orient: 'vertical',
                    left: 'left',
                    selectedMode: false,
                },
                series: [
                    {
                        // name: 'Ventes / Type.',
                        type: 'pie',
                        radius: ['40%', '60%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                        },
                        label: {
                            show: true,
                            overflow: 'break',
                            width: 75,
                        },
                        labelLine: {
                            show: true
                        },
                        data: this.chartData,
                    }
                ]
            });
            this.chart.on('click', (params) => this.$emit('change', params.data));
        },
    },
    computed : {

        chartData () {
            return _.map(this.dataByType, data => ({ id: data.id, value: data.value, name: `${data.name}`, tooltip: { valueFormatter: (value) => value }}))
        },
        dataByType() {
            return this.dataByQty;   
        },
        summarizedData () {
            if (this.max >= 0) {
                return _.slice(this.dataByType, 0, this.max);
            } else {
                return this.dataByType;
            }
           
        },
        dataByQty () {
            return _.orderBy(_.map(this.data, d => ({id: d.fee_type, name: this.$t(`reports.feeTypes.${d.fee_type}`), value: Number(d.qty), value9L: Number(d.qty9l) })), ['qty'], ['desc']);
        },
        ...mapState('controlData', ['rebate_types']),
    },
    mounted() {
        this.init();
    }
   
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


</style>
  